import styled from 'styled-components';

import { Button } from '@gympass/yoga';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: capitalize;
`;

export const ButtonIcon = styled(Button.Icon)<{ hide: boolean }>`
  background: transparent;
  opacity: ${props => (props.hide ? 0 : 1)};
  cursor: ${({ hide }) => (hide ? 'default' : 'pointer')};

  :active {
    color: initial;
    background: initial;
  }

  > svg {
    fill: ${({ theme }) => theme.yoga.colors.primary};
  }
`;

export const Date = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
`;
